import { render, staticRenderFns } from "./MtExpiryReturns.vue?vue&type=template&id=36630b09&"
import script from "./MtExpiryReturns.vue?vue&type=script&lang=js&"
export * from "./MtExpiryReturns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports